(() => {
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
  const routes = window.ShopShefia || {};
  const drawer = $('[data-cart-drawer]');
  const shade = $('.ss-drawer-shade');

  function openDrawer() {
    if (!drawer || !shade) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    shade.hidden = false;
    document.body.classList.add('ss-no-scroll');
    $('[data-cart-close]', drawer)?.focus();
  }

  function closeDrawer() {
    if (!drawer || !shade) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    shade.hidden = true;
    document.body.classList.remove('ss-no-scroll');
  }

  function money(cents, currency = 'USD') {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const body = $('[data-cart-body]');
    if (!body) return;
    body.textContent = '';
    if (!cart.item_count) {
      const empty = document.createElement('div');
      empty.className = 'ss-empty-cart';
      empty.innerHTML = '<span>♡</span><h3>Your bag is waiting</h3><p>Let’s find something lovely.</p><button class="ss-button ss-button-dark" type="button" data-cart-close>Keep shopping</button>';
      body.append(empty);
      $('[data-cart-close]', empty)?.addEventListener('click', closeDrawer);
      return;
    }

    const items = document.createElement('div');
    items.className = 'ss-drawer-items';
    cart.items.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'ss-mini-product';
      const image = document.createElement('img');
      image.src = item.image || '';
      image.alt = '';
      image.loading = 'lazy';
      const detail = document.createElement('div');
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.product_title;
      const qty = document.createElement('small');
      qty.textContent = `Qty ${item.quantity}`;
      detail.append(link, qty);
      const price = document.createElement('strong');
      price.textContent = money(item.final_line_price, cart.currency);
      row.append(image, detail, price);
      items.append(row);
    });
    const subtotal = document.createElement('div');
    subtotal.className = 'ss-subtotal';
    subtotal.innerHTML = '<span>Subtotal</span>';
    const total = document.createElement('b');
    total.textContent = money(cart.total_price, cart.currency);
    subtotal.append(total);
    const checkout = document.createElement('a');
    checkout.className = 'ss-button ss-button-dark ss-checkout';
    checkout.href = routes.cartUrl || '/cart';
    checkout.textContent = 'View bag and checkout';
    const note = document.createElement('small');
    note.textContent = 'Taxes and shipping calculated at checkout.';
    body.append(items, subtotal, checkout, note);
  }

  async function refreshCart() {
    const response = await fetch(`${routes.cartUrl || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to refresh bag');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  }

  $$('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = $('[data-mobile-menu]');
      const isOpen = menu?.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(Boolean(isOpen)));
    });
  });

  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', openDrawer));
  $$('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-quick-add]');
    if (!form) return;
    event.preventDefault();
    const button = $('button[type="submit"]', form);
    if (button) { button.disabled = true; button.textContent = 'Adding...'; }
    try {
      const response = await fetch(`${routes.cartAddUrl || '/cart/add'}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Unable to add item');
      await refreshCart();
      openDrawer();
    } catch (error) {
      window.alert('This item could not be added. Please try again.');
    } finally {
      if (button) { button.disabled = false; button.innerHTML = 'Quick add <span>+</span>'; }
    }
  });

  $$('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });
})();

document.addEventListener('click', (event) => {
  document.querySelectorAll('.ss-shop-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.ss-shop-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
});
